import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../../../actions/Masters/genre";
import Export from "../../utils/Export";
import { bindActionCreators } from "redux";
import UltimateDataTable from "../../utils/UltimateDataTable";
import DynamicFormModal from "../../utils/NewFormStructure/DynamicFormModal";

const Genre = () => {
  const dispatch = useDispatch();
  const rights = useSelector((state) => state.layout.rights);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [save, setSave] = useState(false);
  const user = useSelector((state) => state.layout.profile);
  const [form, setForm] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const { genre_create, genre_update, all_genre_list } = bindActionCreators(
    Action,
    dispatch
  );
  const [genreData, setGenreData] = useState([]);

  useEffect(() => {
    const genreData = async () => {
      try {
        const resData = await all_genre_list();
        if (resData?.status === 200) {
          setGenreData([...resData?.data?.data]);
        }
      } catch (ele) {
        console.error(ele);
      } finally {
        setLoading(false);
      }
    };
    genreData();
  }, [save]);

  const handleEdit = async (data) => {
    setForm(data);
    setIsModalOpen(true);
    setIsEdit(true);
  };

  useEffect(() => {
    if (!isModalOpen) {
      setIsEdit(false);
    }
  }, [isModalOpen]);

  const handleSubmit1 = async (event) => {
    // event.preventDefault();
    if (isEdit) {
      const resData = await genre_update(form);
      if (resData?.status === 200) {
        setIsModalOpen(false);
        setSave(!save);
        setForm({});
        // navigate("/masters/category/", { state: { formUpload: true } });
      } else {
        setForm(form);
        // setIsModalOpen(true)
      }
    } else {
      const resData = await genre_create(form);
      if (resData?.status === 200) {
        setForm({});
        setIsModalOpen(false);
        setSave(!save);
        // navigate("/masters/category/", { state: { formUpload: true } });
      } else {
        setForm(form);
        // setIsModalOpen(true)
      }
    }
  };

  const FormStructure = [
    {
      type: "inputBox",
      name: "genre",
      title: "Genre",
      placeholder: "Enter genre ",
      regex: /^[a-zA-Z\s\&]+$/,
      required: true,
    },
  ].filter((e) => e);
  const columns = [
    {
      accessorKey: "genre",
      header: "Genre",
      cellType: "genre",
      // minWidth: "200px",
      enableSorting: true,
    },

    // {
    //   accessorKey: "status",
    //   header: "Status",
    //   filterable: true,
    //   filterType: "select",
    //   filterOptions: [
    //     { value: "Active", label: "Active" },
    //     { value: "Inactive", label: "Inactive" },
    //     { value: "Pending", label: "Pending" },
    //   ],
    //   cellType: "status",
    //   minWidth: "120px",
    // },
    // {
    //   accessorKey: "created_at",
    //   header: "Created Date",
    //   filterable: true,
    //   filterType: "date",
    //   cellType: "date",
    //   minWidth: "140px",
    // },
  ];

  return (
    <div>
      <DynamicFormModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setForm({});
          setIsEdit(false);
        }}
        formStructure={FormStructure}
        onSubmit={handleSubmit1}
        formData={form}
        setFormData={setForm}
        title={isEdit ? "Edit Genre" : "Add Genre"}
        initialData={{}}
      />
      <UltimateDataTable
        title="Genre Management System"
        subtitle="Manage Genre with advanced filtering and controls"
        columns={columns}
        serverSide={false}
        staticData={genreData}
        // loadApi={loadUsers}
        // exportApi={exportUsersApi}
        onAdd={() => setIsModalOpen(true)}
        onEdit={(data) => handleEdit(data)}
        // onView={(user) => console.log("View user:", user)}
        onDelete={(user) => console.log("Delete user:", user)}
        // onBulkAction={(action, ids) => console.log('Bulk action:', action, ids)}
        height="500px"
      />
    </div>
  );
};

export default Genre;
